import React from "react";
import UiIcon from "../../ui/icons/uiIcon";

const MaterialsWizardDoneCheckMark = () => {
  return (
    <div className="selection-footer-list__item-done selection-footer-list__item-done--svg">
      <UiIcon icon="checkmark" color="white"/>
    </div>
  )
};
export default MaterialsWizardDoneCheckMark
